import { render, staticRenderFns } from "./user_avatar_link.vue?vue&type=template&id=79a69b4c&"
import script from "./user_avatar_link.vue?vue&type=script&lang=js&"
export * from "./user_avatar_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports